import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { PublicLayout } from "./components/PublicLayout";
import { HomePage } from "./pages/HomePage";
import { CatalogPage } from "./pages/CatalogPage";
import { ProductPage } from "./pages/ProductPage";
import { AboutPage, CollectionsPage, ContactPage } from "./pages/InfoPages";
import { AdminLoginPage } from "./pages/AuthPage";
import { AdminPage } from "./pages/AdminPage";
import { Brand } from "./components/Brand";

function PageMeta() {
  const location = useLocation();
  useEffect(() => {
    const names: Record<string,string> = { "/": "KinesLima — Lencería con atención privada", "/catalogo": "Catálogo | KinesLima", "/colecciones": "Colecciones | KinesLima", "/nosotros": "Nosotros | KinesLima", "/contacto": "Contacto privado | KinesLima" };
    document.title = location.pathname.startsWith("/producto/") ? "Detalle de producto | KinesLima" : location.pathname.startsWith("/admin") ? "Administración | KinesLima" : names[location.pathname] ?? "KinesLima";
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);
  return null;
}

function AgeNotice() {
  const [visible, setVisible] = useState(() => localStorage.getItem("kineslima-age-confirmed") !== "yes");
  if (!visible) return null;
  const confirm = () => { localStorage.setItem("kineslima-age-confirmed", "yes"); setVisible(false); };
  return <div className="age-notice-backdrop" role="dialog" aria-modal="true" aria-labelledby="age-title"><div className="age-notice"><Brand /><span className="age-shield"><ShieldCheck /></span><h2 id="age-title">Una experiencia pensada para adultos</h2><p>KinesLima es un catálogo de lencería dirigido exclusivamente a personas mayores de 18 años.</p><button className="primary-button justify-center" onClick={confirm}>Soy mayor de 18 años</button><a href="https://www.google.com">Salir del sitio</a></div></div>;
}

export function App() {
  return <><PageMeta /><Routes>
    <Route element={<PublicLayout />}>
      <Route index element={<HomePage />} />
      <Route path="catalogo" element={<CatalogPage />} />
      <Route path="colecciones" element={<CollectionsPage />} />
      <Route path="producto/:slug" element={<ProductPage />} />
      <Route path="nosotros" element={<AboutPage />} />
      <Route path="contacto" element={<ContactPage />} />
      <Route path="favoritos" element={<CatalogPage />} />
      <Route path="privacidad" element={<AboutPage />} />
    </Route>
    <Route path="/admin/login" element={<AdminLoginPage />} />
    <Route path="/admin/*" element={<AdminPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes><AgeNotice /></>;
}
